const Routes = {
  Landing: "/",
  About: "/about",
  Community: "/community",
  AlbaniaTool: "/albania-tool",
  AlbaniaStory: "/accelerating-growth-in-albania",
  JordanTool: "/jordan-tool",
  JordanOverview: "/jordan-project-overview",
  BestOf2020: "/best-of-2020",
  BestOf2021: "/best-of-2021",
  BestOf2022: "/best-of-2022",
  BestOf2024: "/best-of-2024",
  BestOf2025: "/best-of-2025",
  NamibiaTool: "/namibia-tool",
  CustomProductSpace: "/custom-product-space",
  CustomIndustrySpace: "/custom-industry-space",
  PortEcosystemsStory: "/port-ecosystems",
  NamibiaWalvisBay: "/namibia-walvis-bay",
  GreenGrowth: "/greenplexity",
  DesignLibrary: "/design-library",
  // Green Growth sub-routes
  GreenGrowthTutorial: "/greenplexity/tutorial",
  GreenGrowthValueChainsProducts: "/greenplexity/value-chains-products",
  GreenGrowthValueClusters: "/greenplexity/value-clusters",
  GreenGrowthClusterProducts: "/greenplexity/cluster-products",
  GreenGrowthCompetitiveness: "/greenplexity/competitiveness",
  GreenGrowthClusterTrade: "/greenplexity/cluster-trade",
  GreenGrowthClusterMarket: "/greenplexity/cluster-market",
  GreenGrowthStrategy: "/greenplexity/strategy",
  GreenGrowthOpportunities: "/greenplexity/opportunities",
  GreenGrowthConnections: "/greenplexity/connections",
  GreenGrowthProducts: "/greenplexity/products",
  GreenGrowthExplore: "/greenplexity/explore",
  // Rankings route
  GreenGrowthRankings: "/greenplexity/rankings",
  SpaceVisualizer: "/space-viewer",
};

const defaultTitle = "The Growth Lab at Harvard Kennedy School";
const defaultDescription =
  "Translating Growth Lab research into powerful online tools and interactive storytelling";
const defaultOgImage = "default.png";
const defaultFavicon = "/favicon.svg";

const metadata = [
  {
    url: Routes.Landing,
    title: "Harvard Growth Lab Viz Hub | " + defaultTitle,
    description: defaultDescription,
    og_image: "growth-lab-hub.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.About,
    title: "About | " + defaultTitle,
    description: defaultDescription,
    og_image: "growth-lab-hub.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.Community,
    title: "Community | " + defaultTitle,
    description: defaultDescription,
    og_image: "growth-lab-hub.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.AlbaniaTool,
    title: "Albania's Industry Targeting Dashboard | " + defaultTitle,
    description: "View data visualizations for Albania's industries.",
    og_image: "albania-dashboard-card-background.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.AlbaniaStory,
    title:
      "Can Albania's Economic Turnaround Survive COVID-19? A Growth Diagnostic Update | " +
      defaultTitle,
    description:
      "This brief analysis takes stock of Albania's economic growth prior to the COVID-19 crisis and what the strengths and weaknesses of the pre-COVID economy imply for recovery and the possibility of accelerating long-term and inclusive growth in the years to come. Albania is a place where much has been achieved to expand opportunity and well-being as growth has gradually accelerated since 2013-14, but where much remains to be done to continue this acceleration once the immediate crisis of COVID-19 has passed.",
    og_image: "albania-story-card-background.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.JordanTool,
    title:
      "A Roadmap for Export Diversification: Jordan's Complexity Profile | " +
      defaultTitle,
    description:
      "This tool displays the results of the complexity analysis developed for Jordan by the Growth Lab at Harvard University.",
    og_image: "jordan-tool-background.png",
    favicon: defaultFavicon,
  },
  {
    url: Routes.JordanOverview,
    title:
      "A Roadmap for Export Diversification: Jordan's Complexity Profile | " +
      defaultTitle,
    description:
      "This tool displays the results of the complexity analysis developed for Jordan by the Growth Lab at Harvard University.",
    og_image: "jordan-tool-background.png",
    favicon: defaultFavicon,
  },
  {
    url: Routes.BestOf2020,
    title: "15 Visual Insights from the Growth Lab in 2020 | " + defaultTitle,
    description:
      "2020's most notable visual insights from faculty, fellows, researchers and staff at Harvard's Growth Lab.",
    og_image: "best-of-2020-share-image.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.BestOf2021,
    title:
      "Visual Insights from the Growth Lab's 2021 Research | " + defaultTitle,
    description:
      "2021's most notable visual insights from faculty, fellows, researchers and staff at Harvard's Growth Lab.",
    og_image: "best-of-2021-share-image.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.BestOf2022,
    title:
      "Visual Insights from the Growth Lab's 2022 Research | " + defaultTitle,
    description:
      "2022's most notable visual insights from faculty, fellows, researchers and staff at Harvard's Growth Lab.",
    og_image: "best-of-2022-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.BestOf2024,
    title:
      "Visual Insights from the Growth Lab's 2024 Research | " + defaultTitle,
    description:
      "2024's most notable visual insights from faculty, fellows, researchers and staff at Harvard's Growth Lab.",
    og_image: "best-of-2024-share-image.png",
    favicon: defaultFavicon,
  },
  {
    url: Routes.BestOf2025,
    title:
      "Visual Insights from the Growth Lab's 2025 Research | " + defaultTitle,
    description:
      "2025's most notable visual insights from faculty, fellows, researchers and staff at Harvard's Growth Lab.",
    og_image: "best-of-2025-share-image.png",
    favicon: defaultFavicon,
  },
  {
    url: Routes.NamibiaTool,
    title: "Namibia's Industry Targeting Dashboard | " + defaultTitle,
    description: "View data visualizations for Namibia's industries.",
    og_image: defaultOgImage,
    favicon: defaultFavicon,
  },
  {
    url: Routes.PortEcosystemsStory,
    title:
      "Harboring Opportunity: The Industrial Ecosystems of Port Cities | " +
      defaultTitle,
    description:
      "Commercial ports are crucial to the world economy in driving trade and globalization, but they also play a strong role in shaping their local economies. In this analysis, we investigate the industrial composition of port cities and the types of activities that tend to concentrate more heavily near ports. We assess which of these activities are closely linked to port operations, which of these activities simply occur more frequently in port cities. The analysis suggests ways that these insights can be useful to policymakers seeking to develop and diversify port cities.",
    og_image: "harboring-opportunity-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.NamibiaWalvisBay,
    title:
      "Port Resiliency in the Face of Global Shocks: The Case of Walvis Bay in Namibia | " +
      defaultTitle,
    description:
      "The article explores the economic resilience of ports in the face of global shocks, with particular focus on the port of Walvis Bay, Namibia. Walvis Bay faces challenges in attracting volume due to its relative unconnectedness to population centers in Africa, but it experienced a fourteen-fold increase in containerized cargo volumes during the global commodity super-cycle. This was due to its efficient operations and relative competitiveness. However, containerized traffic plummet at the end of the cycle and volumes have struggled to recover since. The article  discusses the potential opportunities for growth in the future by capitalizing on global developments in clean energy technologies and the closeness to mining operations in the region, whereby Walvis Bay can serve as a regional logistics hub for exports.",
    og_image: "namibia-walvis-bay-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowth,
    title: "Greenplexity | " + defaultTitle,
    description:
      "Identify green growth opportunities to generate prosperity by supplying what the world needs to decarbonize.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthTutorial,
    title: "Tutorial: Green Value Chains | " + defaultTitle,
    description:
      "An interactive tutorial introducing green value chains hierarchy, showing how different components build upon each other from raw materials to final products in the green economy.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthValueChainsProducts,
    title: "Green Value Chains Products | " + defaultTitle,
    description:
      "Explore the green value chains and products that drive the transition to a sustainable economy.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthValueClusters,
    title: "Green Value Clusters | " + defaultTitle,
    description:
      "Discover clusters of green industries and their interconnections in the global economy.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthClusterProducts,
    title: "Green Cluster Products | " + defaultTitle,
    description:
      "Analyze products within green industry clusters and their relationships.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthCompetitiveness,
    title: "Green Competitiveness | " + defaultTitle,
    description:
      "Assess competitiveness in green industries and identify opportunities for growth.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthClusterTrade,
    title: "Green Cluster Trade | " + defaultTitle,
    description:
      "Explore trade flows and patterns within green industry clusters.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthClusterMarket,
    title: "Green Cluster Market | " + defaultTitle,
    description:
      "Analyze market opportunities and dynamics in green industry clusters.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthStrategy,
    title: "Green Growth Strategy | " + defaultTitle,
    description:
      "Develop strategies for green growth opportunities and economic transformation.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthOpportunities,
    title: "Green Growth Opportunities | " + defaultTitle,
    description:
      "Identify opportunities for green growth based on economic complexity analysis.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthConnections,
    title: "Green Growth Connections | " + defaultTitle,
    description:
      "Explore connections between green industries and pathways to diversification.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthProducts,
    title: "Green Products | " + defaultTitle,
    description:
      "Browse the landscape of green products and their role in the energy transition.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthExplore,
    title: "Explore Green Growth | " + defaultTitle,
    description:
      "Explore the complete dataset of green industries, products, and value chains.",
    og_image: "greenplexity-card-background-lo.jpg",
    favicon: defaultFavicon,
  },
  {
    url: Routes.GreenGrowthRankings,
    title: "Green Growth Rankings | " + defaultTitle,
    description:
      "View country rankings and performance in green industries and technologies.",
    og_image: "greenplexity-card-background-lo.jpg",
  },
  {
    url: Routes.SpaceVisualizer,
    title: "Growth LabSpace Viewer",
    description:
      "Interactive visualization of product space and industry relationships",
    og_image: defaultOgImage,
    favicon: defaultFavicon,
  },
  {
    url: Routes.DesignLibrary,
    title: "Design Library | " + defaultTitle,
    description:
      "A collection of design guidelines and assets used in the Growth Lab's visualizations",
    og_image: defaultOgImage,
    favicon: defaultFavicon,
  },
];

const get = (route) => {
  const data = metadata.find(({ url }) => url === route);
  if (data) {
    return data;
  } else {
    return {
      url: route,
      title: "Harvard Growth Lab Viz Hub | " + defaultTitle,
      description: defaultDescription,
      og_image: defaultOgImage,
      favicon: defaultFavicon,
    };
  }
};

module.exports = {
  metadata,
  Routes,
  get,
};
